import legal from "./content/legal.json";
import { useI18n } from "./i18n";

function InstagramIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" />
    </svg>
  );
}

function FooterLogo() {
  const { language } = useI18n();
  return (
    <a className="logo logo--compact" href={`/${language}/`} aria-label="Tiago de Paula BJJ home">
      <span className="logo__mark"><img src="/images/logo.svg" alt="" /></span>
      <span className="logo__type"><strong>TIAGO DE PAULA</strong><small>BRAZILIAN JIU-JITSU</small></span>
    </a>
  );
}

export default function UniversalFooter() {
  const { content: { site }, ui, language } = useI18n();
  const partnerDojo = site.dojos.find((dojo) => dojo.partner_logo);
  const root = `/${language}/`;

  return (
    <footer className="footer landing-universal-footer">
      <div className="section-shell footer__top">
        <FooterLogo />
        {partnerDojo && (
          <div className="footer__partner">
            <img src={partnerDojo.partner_logo} alt={partnerDojo.partner_logo_alt || partnerDojo.partner_name || "Partner logo"} loading="lazy" />
            <div><strong>{partnerDojo.partner_name || partnerDojo.partner_logo_alt}</strong><span>MMA</span></div>
          </div>
        )}
        <div className="footer__locations">
          {site.dojos.map((dojo) => (
            <div className="footer__location" key={dojo.id}>
              <div className="footer__location-copy"><strong>{dojo.name}</strong><span>{dojo.address}</span></div>
            </div>
          ))}
        </div>
        <div className="footer__links">
          <a href={site.instagram_profile} target="_blank" rel="noreferrer"><InstagramIcon /> {ui.footer.instagram}</a>
          <a href={`${root}#schedule`}>{ui.footer.schedule}</a>
          <a href={`${root}#trial`}>{ui.footer.trial}</a>
          <a href={`${root}no-gi-bjj-zurich/`}>No-Gi BJJ</a>
          <a href={`${root}private-bjj-lessons-zurich/`}>{language === "de" ? "Privatlektionen" : "Private Lessons"}</a>
          <a href={`${root}competition-bjj-zurich/`}>Competition BJJ</a>
        </div>
      </div>
      <div className="section-shell footer__bottom">
        <span>
          © {new Date().getFullYear()} Tiago de Paula BJJ
          {" · "}{language === "de" ? "Entwickelt von" : "Developed by"} <a href="https://codelapa.com" target="_blank" rel="noreferrer">Codelapa</a>
          {" · "}{language === "de" ? "Konzept und Design von" : "Concept and design by"} <a href="https://www.linkedin.com/in/maurantoniom/" target="_blank" rel="noreferrer">Michael Maurantonio</a>
        </span>
        <nav className="footer__legal" aria-label={language === "de" ? "Rechtliche Informationen" : "Legal information"}>
          <a href="/documents/dojo-rules.pdf" target="_blank" rel="noreferrer">{ui.footer.rules}</a>
          {legal.documents.map((document) => (
            <a href={`${root}#${document.id}`} key={document.id}>
              {language === "de" ? document.title_de : document.title_en}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
}
